export const environment = {
  apiUrl: 'https://sgi-api-hml.unimedinconfidentes.coop.br/v1',
  production: false,
  environment: 'development',
  aplicacaoId: '363d4a7a-55cd-4676-9536-8be755bbc996',
};